import React from 'react';
import { defaultSettings } from '../../../../modules/slider/sliderSettings';
import ProductCard from './productCard/productCard';
import {BreakPtMobile} from '../../../../assets/sass/export.module.scss';
import {default as ReactSlider} from "react-slick";
import {relatedContent} from './relatedContent.module.scss';
/**
 * Related content slider
 * 
 */
const RelatedContent = ({data, className, id, intl, ...other}) => {    
  const sliderSettings = {
    adaptiveHeight: true,
    slidesToScroll: 1,
    slidesToShow: data.length > 1 ? 2 : 1,
    responsive: [
      {
        breakpoint: parseInt(BreakPtMobile),
        settings: {
          slidesToShow: 1,
        }
      }
    ],
    ...defaultSettings
  }
  
  return (
    <section className={` ${relatedContent} ${className || ''}`} data-addsearch="exclude" {...other}>
      <div className="container">
        {
          <ReactSlider {...sliderSettings}>
            {
              data?.map((product, i)=>{
                return <ProductCard key={i} data={product}/>
              })
            }
          </ReactSlider>
        }
      </div>
    </section>
  );
};

export default RelatedContent;
